import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios'; // Import Axios
import { Header } from "../../../components/Header";
import { Header_New } from '../../../components/Header_new';
import { Popup } from "../../../components/Popup"
import "./style.css";
import { getAnalytics, logEvent } from 'firebase/analytics';

const ReadingFreechoice = () => {
  const analytics = getAnalytics();
  logEvent(analytics, 'readingfreechoice');
  const [showPopup, setShowPopup] = useState(true);
  const [popupInputValues, setPopupInputValues] = useState({ value1: '', value2: '' });
  const [isPopupNeeded, setIsPopupNeeded] = useState(false);
  const [input, setInput] = useState('');
  const [story, setStory] = useState('');
  const [conversationId, setConversationId] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const bookId = params.bookId;
  const checkPopupNecessity = async (bookId) => {
    try {
      const response = await axios.post('https://picked-chigger-top.ngrok-free.app/check_popup/', {
        bookId 
      }, {
        headers: {
          'Content-Type': 'application/json',
          'ngrok-skip-browser-warning': 'true'
        }
      });
      
      setIsPopupNeeded(response.data.isPopupNeeded);
      // If the popup is not needed, you might want to start the story directly
      if (!response.data.isPopupNeeded) {
        const id = await startStory(bookId, '', '');
        continueStory("Start the Story but stay in your desired language.", id);
      }
    } catch (error) {
      console.error('Error checking popup necessity: ', error);
      setError("Fehler beim Überprüfen der Popup-Notwendigkeit. Bitte versuchen Sie es später erneut.");
    }
  };
  const closePopup = () => {
    setShowPopup(false);
  };
  const handlePopupSubmitNOContent = async () => {
    closePopup();
    const input1 = ""; // Value from first input
    const input2 = "";
    const id = await startStory(bookId,input1,input2); // Use the input from the popup here
    continueStory("Start the Story but stay in your desired language.", id);
  };
  const handlePopupSubmit = async () => {
    closePopup();
    const input1 = popupInputValues.value1; // Value from first input
    const input2 = popupInputValues.value2;
    const id = await startStory(bookId,input1,input2); // Use the input from the popup here
    continueStory("Start the Story but stay in your desired language.", id);
  };
  const startStory = async (topic, input1,input2) => {
    console.log(topic)
    console.log(input1)
    console.log(input2)
    try {
      setLoading(true);
      const response = await axios.post('https://picked-chigger-top.ngrok-free.app/start/', {
      topic, 
      input1, 
      input2  
    }, {
      headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true'
      }
    });
      setConversationId(response.data.chat_session_id);
      setStory('');
      console.log(response.data.chat_session_id);
      setLoading(false);
      return response.data.chat_session_id;
    } catch (error) {
      setLoading(false);
      console.error('Error starting story: ', error);
      setError("Fehler beim starten der Geschichte. Bitte versuchen Sie es später erneut.");
    }
  };

  const continueStory = async (currentInput, curchatID) => {
    console.log(currentInput);
    console.log(curchatID);
    try {
      setLoading(true);
      const response = await axios.post('https://picked-chigger-top.ngrok-free.app/continue/', {
        user_input: currentInput,
        chat_session_id: curchatID,
      }, {
        headers: {
          'Content-Type': 'application/json',
          'ngrok-skip-browser-warning': 'true'
        }
      });
      setStory(response.data.response);
      console.log(story);
      setInput('');
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Error continuing story: ', error);
      setError("Fehler beim weiterführen der Geschichte. Bitte versuchen Sie es später erneut.");
    }
  };
  const downloadStory = async (curchatID) => {
    try {
      const response = await axios.post(
        'https://picked-chigger-top.ngrok-free.app/download_story/',
        { chat_session_id: curchatID },
        {
          responseType: 'blob',  // Important for handling the file download
          headers: {
            'Content-Type': 'application/json',
            'ngrok-skip-browser-warning': 'true'
          }
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'geschichte.txt');
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      console.error('Error downloading story: ', error);
      setError("Fehler beim herunterladen Ihrer Geschichte. Bitte versuchen sie es später erneut.")
    }
  };
  useEffect(() => {
    checkPopupNecessity(bookId);
    // Remove or comment out onSideLoad(bookId) if you handle starting the story in checkPopupNecessity
    // onSideLoad(bookId);
  }, [bookId]);
  return (
    <div className="reading-freechoice">
      <div className='main-content'>
      <Header_New />
      {isPopupNeeded && showPopup && (
        <Popup 
        isVisible={showPopup}
        onClose={handlePopupSubmitNOContent}
        onContinue={handlePopupSubmit}
        setInputValue1={(value) => setPopupInputValues({ ...popupInputValues, value1: value })}
        setInputValue2={(value) => setPopupInputValues({ ...popupInputValues, value2: value })}
        inputValues={popupInputValues}
      />
      )}
        <div className='overlap'>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}
          <div className="option-background">
            <textarea
              value={input}
              onChange={e => setInput(e.target.value)}
              placeholder="Frage hier beantworten..."
            />
          </div>
          {loading && <span className='loader'> </span>}
          <div className="text-backgorund">
            <p className="site-text">{story}</p>
          </div>

          <button onClick={() => {
            continueStory(input, conversationId);
          }} className='continue-button'>Absenden</button>
          <button onClick={() => { downloadStory(conversationId) }} className='download-button'>
            Geschichte herunterladen
          </button>
        </div>
      </div>
      <div className="mobile-warning">
        Bitte drehen Sie ihr Gerät.<img src="https://firebasestorage.googleapis.com/v0/b/weread-45736.appspot.com/o/background%2FturnLandscape.png?alt=media&token=5c863abc-d04b-4bb1-9639-53b4056b88f5"></img>
      </div>
    </div>
  );
};

export default ReadingFreechoice;